// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import postStyleGuideTheme from "@vanmeter/XDL/PostStyle";
import preStyleGuideTheme from "@vanmeter/XDL/PreStyle";
import { theme as defaultTheme } from "@insite/client-framework/Theme"; // Importing nothing to trigger the side effects, which in this case adds custom reducers.
import { setPostStyleGuideTheme, setPreStyleGuideTheme } from "@insite/client-framework/ThemeConfiguration";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import merge from "lodash/merge";

setPreStyleGuideTheme(preStyleGuideTheme);
setPostStyleGuideTheme(postStyleGuideTheme);

// To fix an issue after upgrade v5.0.13 where shareEntity is not working
if (typeof window === "undefined") {
    const customTheme = merge({}, preStyleGuideTheme, postStyleGuideTheme) as any;
    Object.keys(defaultTheme).forEach(key => {
        defaultTheme[key as keyof BaseTheme] = {
            ...customTheme[key],
        };
    });
}
